<template>
  <div class="campaigns-screen">
    <div class="campaigns-screen__wrapper">
      <span class="campaigns-screen__title">Кампании</span>
      <CampaignsFilters
      v-show="showFilters"
      ref="requestFilters"
      class="campaigns-screen__filters"
      @loadCampaignsData="loadCampaignsData" />
      <div
      v-if="isMobile"
      class="campaigns-screen__filters-toggle"
      @click="showFilters = !showFilters">
        <span class="campaigns-screen__title campaigns-screen__title_filters_toggle">{{ showFilters ? 'Скрыть фильтры' : 'Показать фильтры' }}</span>
        <DataIcon
        name="expand_more"
        :arrow-open="showFilters"
        class="campaigns-screen__title campaigns-screen__title_filters_toggle"
        :size="16"
        pointer />
      </div>
      <div class="campaigns-screen__tabs">
        <span
        v-for="tab in getCampaignTabs"
        :key="tab.value"
        :class="{ 'campaigns-screen__tab_selected' : tab.value === selectedCampaignTab }"
        class="campaigns-screen__tab"
        @click="changeSelectedCampaignTab(tab.value)">
          {{ tab.name }}
        </span>
      </div>
      <Campaigns
      :is-loading="isLoading"
      @loadCampaignsData="loadCampaignsData" />
    </div>
  </div>
</template>

<script>
import Campaigns from './components/Campaigns.vue';
import CampaignsFilters from './components/CampaignsFilters.vue';

export default {
  name: 'CampaignsScreen',
  components: { Campaigns, CampaignsFilters },
  data: () => ({
    selectedCampaignTab: 'my',
    showFilters: true,
  }),
  created() {
    this.$store.commit('campaigns/resetCampaignsSearchParams');
    this.$store.commit('campaigns/resetCampaignsOwnerParams');
    this.loadCampaignsData({ reset: true });
  },
  methods: {
    changeSelectedCampaignTab(tab) {
      this.selectedCampaignTab = tab;
      this.loadCampaignsData({ reset: true });
    },
    loadCampaignsData(params) {
      const userId = this.$store.getters['user/getUserInfo']?.id;

      if (this.selectedCampaignTab === 'my') {
        if (this.isManager) {
          const ownerParams = { requestPlacementResponsibleUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', this.isActiveFilters ? {} : ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isAdmin) {
          const ownerParams = { agencyResponsibleUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        const ownerParams = { creatorUserId: userId };
        this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
        this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
        return;
      }

      if (this.selectedCampaignTab === 'archive') {
        if (this.isManager) {
          const ownerParams = { isArchived: true, agencyResponsibleUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isAdmin) {
          const ownerParams = { isArchived: true };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isClientAgency) {
          const ownerParams = { isArchived: true, creatorUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        // агентство или прямой рекл (avertiser)
        const agencyId = this.$store.getters['user/getUserInfo']?.asEmployerAgency?.id;
        const ownerParams = { isArchived: true, ownerAgencyId: agencyId };
        this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
        this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
        return;
      }

      // ВКЛАДКА ВСЕ ЗАПРОСЫ
      if (this.selectedCampaignTab === 'all') {
        if (this.isManager) {
          const ownerParams = { agencyResponsibleUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isAdmin) {
          this.$store.commit('campaigns/setCampaignsOwnerParams', {});
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isAgency || this.isAdvertiser) {
          const agencyId = this.$store.getters['user/getUserInfo']?.asEmployerAgency?.id;
          const ownerParams = { ownerAgencyId: agencyId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        if (this.isClientAgency) {
          const ownerParams = { isArchived: true, creatorUserId: userId };
          this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
          this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
          return;
        }
        const agencyId = this.$store.getters['user/getUserInfo']?.asEmployerAgency?.id;
        const ownerParams = { ownerAgencyId: agencyId };
        this.$store.commit('campaigns/setCampaignsOwnerParams', ownerParams);
        this.$store.dispatch('campaigns/loadCampaignsData', { reset: params.reset });
      }
    },
  },
  computed: {
    isAdmin() {
      return this.$store.getters['user/getIsAdmin'];
    },
    isAgency() {
      return this.$store.getters['user/getIsAgency'];
    },
    isManager() {
      return this.$store.getters['user/getIsManager'];
    },
    isClientAgency() {
      return this.$store.getters['user/getUserInfo']?.asClientAgency;
    },
    isAdvertiser() {
      return this.$store.getters['user/getIsAdvertiser'];
    },
    isLoading() {
      return this.$store.getters['app/getAppIsLoading'];
    },
    getCampaignTabs() {
      if (this.isAdmin) {
        return this.campaignTabs;
      }
      return this.campaignTabs.filter((item) => item.show);
    },
    campaignTabs() {
      return [
        { name: 'Мои кампании', value: 'my', show: true },
        { name: 'Все кампании', value: 'all', show: !this.isClientAgency },
        { name: 'Архив', value: 'archive', show: true },
      ];
    },
    isMobile() {
      return window.innerWidth < 768;
    },
  },
};
</script>

<style lang="scss" scoped>
.campaigns-screen__wrapper {
  margin: 0px 20px;
  height: calc(100vh - 90px);
  display: flex;
  flex-direction: column;
}

.campaigns-screen__title {
  font-size: 18px;
  font-weight: 600;
  &_filters_toggle {
    font-weight: 500;
    font-size: 16px;
    color: $primary-blue;
  }
}

.campaigns-screen__tabs {
  margin-top: 20px;
  @include between-elements {
    margin-right: 15px;
  }
}

.campaigns-screen__tab {
  color: rgba($primary-gray, 0.5);
  font-size: 13px;
  transition: 0.2s;
  cursor: pointer;
  position: relative;
  &_selected {
    color: $primary-blue;
    &:after {
      position: absolute;
      top: 20px;
      left: 0px;
      content: '';
      width: 100%;
      height: 1px;
      background: $primary-blue;
    }
  }
}

.campaigns-screen__filters {
  margin-top: 10px;
}

.campaigns-screen__filters-toggle {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-top: 20px;
  cursor: pointer;
  @include between-elements {
    margin-right: 5px;
  }
}
</style>
